export default __webpack_public_path__ + "static/media/confirmation_icon.1a70883d.png";